<template>
  <div class="error-page">
    <img class="logo" src="/dist/cisecurity/assets/images/CIS_logo.svg" />
    <div class="error-message">
      <h1>404</h1>
      <h2>Page not found</h2>
      <p>
        Hmm, it looks like the page you wanted doesn't exist.
        <router-link to="/">Go back to the homepage</router-link> or
        <router-link to="/search?s=">try searching for something else.</router-link>
      </p>
    </div>
  </div>
</template>

<script>
import { useHead } from '@unhead/vue';

export default {
  name: 'not-found',
  setup() {
    useHead({
      title: 'Page Not Found'
    });
  },
  props: {
    context: {
      type: Object
    }
  }
};
</script>

<style lang="scss" scoped>
h1,
h2 {
  font-family: 'Arial', sans-serif;
  color: #0086bf;
  // background: -webkit-linear-gradient(#003b5c, #0086bf);
  background: linear-gradient(
    169deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(0, 59, 92, 1) 20%,
    rgba(0, 134, 191, 1) 100%
  );
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
h1 {
  font-weight: 100;
  font-size: 10rem;
  line-height: 10rem;
  @include desktop-up {
    font-size: 17rem;
    line-height: 15rem;
  }
}
h2 {
  font-weight: 200;
  line-height: normal;
  font-size: 3.6rem;
  margin: 2rem auto;
}
.error {
  &-page {
    margin: 8px;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  &-message {
    text-align: center;
    max-width: 460px;
    p {
      @include font-styles('Arial', 2rem, 200, normal, 2.6rem, 0, $dark-gray);
    }
    a {
      font-weight: 500;
      &:hover {
        text-decoration: none;
      }
    }
  }
}
.logo {
  max-width: 75%;
  width: 28rem;
  mix-blend-mode: multiply;
}
</style>
